module.exports = __webpack_public_path__ + "img/Start Engine.e271e1ff.png";